/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Button, Modal } from '@mairistem/composants';
import { request } from '@mairistem/tools';

import { useHubeeRetour } from '@mairistem/administres-utils';

import { useCreateIndividu, useUpdateIndividu } from '@/hooks';

const ModalEnvoieAttestation = ({
  onCancel,
  onOpen,
  open,
  nomRecense,
  identifiantTeledossier,
  individu,
  individuBrouillonId,
  onError,
}) => {
  const { createIndividu } = useCreateIndividu();
  const { updateIndividu } = useUpdateIndividu();
  const { navigateBack } = useHubeeRetour();
  const [loading, setLoading] = React.useState(false);

  const handleCreerIndividuEtTraiter = React.useCallback(
    (attestationEnvoyee = false) => {
      setLoading(true);

      // Si on a un individuBrouillonId, on update l'individu pour enlever le mode brouillon
      // Sinon on crée l'individu (mode normal, non-Hubee)
      const individuPromise = individuBrouillonId
        ? updateIndividu(individuBrouillonId)
        : createIndividu(individu);

      individuPromise
        .then(() => {
          // 2. Traiter le télédossier
          if (!identifiantTeledossier) {
            navigateBack('/hubee', `/hubee/${identifiantTeledossier}`);
            return;
          }

          const url = `/api/administres/recensement-citoyen/hubee/teledossiers/${identifiantTeledossier}/traiter`;

          request
            .put(url, {
              attestationEnvoyee,
              identifiantIndividu: individuBrouillonId,
            })
            .then(() => {
              // Rediriger selon la provenance
              navigateBack(
                '/hubee', // URL pour retour à la liste
                `/hubee/${identifiantTeledossier}`, // URL pour retour à la demande
              );
            })
            .catch(() => {
              // En cas d'erreur, on redirige quand même
              navigateBack('/hubee', `/hubee/${identifiantTeledossier}`);
            })
            .finally(() => {
              setLoading(false);
            });
        })
        .catch(() => {
          onError();
          setLoading(false);
        });
    },
    [
      identifiantTeledossier,
      individu,
      individuBrouillonId,
      onError,
      createIndividu,
      updateIndividu,
      navigateBack,
    ],
  );

  return (
    <Modal
      onOpen={onOpen}
      open={open}
      onClose={onCancel}
      size="small"
      data-testid="modal-envoie-attestation"
    >
      <Modal.Header>Fin du traitement de la demande</Modal.Header>
      <Modal.Content>
        <span>
          Le recensé
          {nomRecense && (
            <>
              {' '}
              <strong>{nomRecense}</strong>
            </>
          )}{' '}
          va être créé. <br />
          <br />
          Souhaitez-vous transmettre l&apos;attestation de recensement au
          demandeur ?
        </span>
      </Modal.Content>
      <Modal.Actions>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button
            content="Annuler la création"
            basic
            onClick={onCancel}
            disabled={loading}
            data-testid="modal-envoie-attestation-annuler"
          />
          <div>
            <Button
              content="Non"
              icon="close"
              basic
              onClick={() => handleCreerIndividuEtTraiter(false)}
              loading={loading}
              disabled={loading}
              data-testid="modal-envoie-attestation-non"
            />
            <Button
              content="Oui"
              icon="check"
              positive
              onClick={() => handleCreerIndividuEtTraiter(true)}
              loading={loading}
              disabled={loading}
              data-testid="modal-envoie-attestation-oui"
            />
          </div>
        </div>
      </Modal.Actions>
    </Modal>
  );
};

export default ModalEnvoieAttestation;
